import { EmbedBuyNowCTA_productizedService$key } from '#app/__generated__/relay/EmbedBuyNowCTA_productizedService.graphql.js';
import { Button } from '#app/components/Buttons/Button.js';
import { Link } from '#app/components/Link/index.js';
import { useAnalytics } from '#app/hooks/useAnalytics.js';
import { useFragment } from '@contra/relay';
import { getRoute } from '@contra/routes';
import { useCallback } from 'react';
import { graphql } from 'relay-compiler';

export const EmbedBuyNowCTA = ({
  productizedServiceRef,
}: {
  readonly productizedServiceRef: EmbedBuyNowCTA_productizedService$key;
}) => {
  const service = useFragment<EmbedBuyNowCTA_productizedService$key>(
    graphql`
      fragment EmbedBuyNowCTA_productizedService on ProductizedService {
        slug
        productizedServiceType
      }
    `,
    productizedServiceRef,
  );
  const canViewPurchaseButton =
    service.productizedServiceType === 'BUY_NOW_OTHER';
  const { slug } = service;
  const { track } = useAnalytics();

  const onClickButton = useCallback(() => {
    track('button', {
      action: 'tapped',
      button_name: 'embedded_buy_now_cta',
    });
  }, [track]);

  return (
    <Button
      as={Link}
      onClick={onClickButton}
      size="small"
      target="_blank"
      to={
        canViewPurchaseButton
          ? getRoute('/s/@slug/checkout', {
              args: { slug },
            })
          : getRoute('/s/@slug', {
              args: { slug },
            })
      }
      variant="V2Primary"
    >
      {canViewPurchaseButton ? 'Buy service' : 'Hire on Contra'}
    </Button>
  );
};
